import Cookies from 'js-cookie';
import { USER_ACCESS_COOKIE } from '../constants/constants';

export const checkTermAcceptBonusJourney = async () => {
  const { bonusJourney } = Cookies.getJSON(USER_ACCESS_COOKIE) || {};
  return bonusJourney && bonusJourney.isAcceptTerm || null;
};

export const updateTermAcceptBonusJourney = async (isAcceptTerm) => {
  const userCookie = await Cookies.getJSON(USER_ACCESS_COOKIE,{
    domain: `${process.env.REACT_APP_DOMAIN}`
  });
  const expiresIn = userCookie?.refreshExpiresIn || userCookie?.expiresIn;
  Cookies.remove(USER_ACCESS_COOKIE, {
    domain: `${process.env.REACT_APP_DOMAIN}`
  });
  Cookies.set(USER_ACCESS_COOKIE, {
      ...userCookie,
      bonusJourney: {
        ...userCookie?.bonusJourney,
        isAcceptTerm,
      },
    },
    {
      domain: `${process.env.REACT_APP_DOMAIN}`,
      expires: new Date(new Date(userCookie?.createAt).getTime() + expiresIn),
    }
  );
};

